if (!customElements.get('product-upsell')) {
  class ProductUpsell extends HTMLElement {
    variantChangedUnsubscriber = undefined;

    constructor() {
      super();

      this.$button = this.querySelector('button');
      this.$productForm = document.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
      this.$productQuickAdd = document.querySelector(`product-quick-add`);
      this.$addButton = this.$productForm.querySelector('button[name="add"]');
      this.$input = null;
      this.$clonedInput = null;

      this.active = JSON.parse(this.getAttribute('aria-current'));

      if (!this.$button && !this.productId && !this.$productForm) {
        return;
      }

      this.$button.addEventListener('click', () => this.handleClick());

      this.variantChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => this.delete());
    }

    handleClick() {
      this.active = !this.active;

      if (this.active) {
        return this.add();
      }

      return this.delete();
    }

    add() {
      this.active = true;

      // Create input
      this.$input = document.createElement('input');
      this.$input.name = 'items[][id]';
      this.$input.value = this.productId;
      this.$input.type = 'hidden';
      this.$addButton = this.$productForm.querySelector('button[name="add"]');

      this.$clonedInput = this.$input.cloneNode(true);

      this.setAttribute('aria-current', 'true');
      this.$button.innerHTML = this.$button.getAttribute('data-delete-label');

      const productPrice = parseInt(this.$productForm.dataset.price, 10);

      this.$addButton.querySelector('span:nth-child(2)').innerHTML = window.productUpsellStrings.add_to_cart.replace(
        '[price]',
        Shopify.formatMoney(productPrice + this.price)
      );
      console.log(this.$addButton);
      if (this.$productQuickAdd) {
        this.$productQuickAdd.querySelector('.js-price').innerHTML = Shopify.formatMoney(productPrice + this.price);
        this.$productQuickAdd.querySelector('product-form').form.append(this.$clonedInput);
      }

      // Append input to product form
      this.$productForm.form.append(this.$input);
    }

    delete() {
      this.active = false;

      this.setAttribute('aria-current', 'false');
      this.$button.innerHTML = this.$button.getAttribute('data-add-label');

      const productPrice = parseInt(this.$productForm.dataset.price, 10);

      this.$addButton.querySelector('span:nth-child(2)').innerHTML = window.productUpsellStrings.add_to_cart.replace(
        '[price]',
        Shopify.formatMoney(productPrice)
      );

      if (this.$productQuickAdd) {
        this.$productQuickAdd.querySelector('.js-price').innerHTML = Shopify.formatMoney(productPrice);

        if (this.$clonedInput) {
          this.$clonedInput.remove();
        }
      }

      // Remove input from product form
      if (this.$input) {
        this.$input.remove();
      }
    }

    disconnectedCallback() {
      if (this.variantChangedUnsubscriber) {
        this.variantChangedUnsubscriber();
      }
    }

    get sectionId() {
      return this.dataset.sectionId;
    }

    get price() {
      return parseInt(this.dataset.price, 10);
    }

    get productId() {
      return this.dataset.productId;
    }
  }

  customElements.define('product-upsell', ProductUpsell);
}
